import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { checkoutUrl, trustLine } from '../data/offer';
export function FinalCTA() {
  return <section className="w-full bg-surface px-4 py-20 text-navy sm:py-24" data-id="element-75" data-mp="c6skzian4add">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-76" data-mp="c83p5j7zzk50">
        <h2 className="font-serif text-5xl leading-tight sm:text-6xl" data-id="element-77" data-mp="84xjacosruz2">
          Sei il rompi-ciclo
          <br data-id="element-78" data-mp="m46okhbgt4o9" />
          <span className="text-amber" data-id="element-79" data-mp="m3ngrtfj3wny">che la tua stirpe stava aspettando.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-80" data-mp="h4u05s4y3pjk">
          Comprendi la tua storia. Riconosci gli schemi. Scegli consapevolmente ciò che vuoi portare con te e ciò che
          vuoi lasciare andare.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-slate" data-id="element-81" data-mp="14vg1l0kg2bkl">
          6 Tomi. 5 Bonus Premium. 300+ pagine. 50 carte. 40 genogrammi. 60 esercizi. 5 meditazioni. Un diario
          strutturato di 90 giorni.
        </p>
        <div className="mx-auto mt-10 max-w-xl rounded-2xl border border-amber/50 bg-mist p-6" data-id="element-82" data-mp="2c5px7w5vve2p">
          <p className="text-sm font-bold uppercase tracking-[0.12em] text-navy" data-id="element-83" data-mp="2h4spsh4ofrts">🚀 Offerta di lancio attiva</p>
          <span aria-hidden="true" className="mx-auto mt-3 block h-px w-24 bg-amber/60" data-id="element-84" data-mp="2m218qjxnfzw3" />
          <p className="mt-3 text-xs font-medium text-slate" data-id="element-85" data-mp="2r2yv78pozg3e">
            5 Bonus Premium inclusi gratuitamente per un periodo limitato.
          </p>
        </div>
        <div className="mt-8" data-id="element-86" data-mp="302c5g3ln48p6">
          <CTAButton href={checkoutUrl} size="large" data-id="element-87" data-mp="301k92qk7y6xu">
            ⚡ ACCESSO ISTANTANEO
          </CTAButton>
        </div>
        <p className="mt-5 text-xs leading-6 text-slate sm:text-sm" data-id="element-88" data-mp="34u3wsgcmeigd">{trustLine}</p>
      </Reveal>
    </section>;
}